import { z } from "zod";

export const createDemoOrgSchema = z.object({
  organization_name: z.string().min(1, "form.organizationName.error.required"),
  bin: z.string().regex(/^\d{12}$/, "form.bin.error.format"),
  chief_surname: z.string().min(1, "form.chiefSurname.error.required"),
  chief_name: z.string().min(1, "form.chiefName.error.required"),
  chief_patronymic: z.string().optional(),
  chief_email: z.string().min(1, "form.chiefEmail.error.required").email("form.chiefEmail.error.invalid"),
  chief_phone: z.string().optional(),
  address_ru: z.string().optional(),
  address_kk: z.string().optional(),
  bank_name: z.string().optional(),
  iban: z.string().optional(),
  bik: z.string().optional(),
  registration_date: z.string().optional(),
  initial_cash: z.string().regex(/^\d*$/, "form.initialCash.error.format").optional(),
  seed_mock_data: z.boolean(),
});

export type CreateDemoOrgFormValues = z.infer<typeof createDemoOrgSchema>;
